import { render, staticRenderFns } from "./ControlledReaderShell.vue?vue&type=template&id=2eae3c08&scoped=true"
import script from "./ControlledReaderShell.vue?vue&type=script&lang=js"
export * from "./ControlledReaderShell.vue?vue&type=script&lang=js"
import style0 from "./ControlledReaderShell.vue?vue&type=style&index=0&id=2eae3c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae3c08",
  null
  
)

export default component.exports